import React from "react";
import { withTranslation, Trans } from "react-i18next";
import { Box, Typography, Grid, Card, Container } from "@mui/material";
import Carousel from "nuka-carousel";
import zombieChef from "../assets/CryptoChefs/zombie.svg";
import hipsterChef from "../assets/CryptoChefs/hipster.svg";
import ninjaChef from "../assets/CryptoChefs/ninja.svg";
import cyborgChef from "../assets/CryptoChefs/cyborg.svg";
import vampireChef from "../assets/CryptoChefs/vampire.svg";
import back from "../assets/Arrows/back-arrow.svg";
import forward from "../assets/Arrows/forward-arrow.svg";
import { ElipseTop, ElipseBottom } from "../utils/theme";
import { NextButton, BackButton } from "../utils/theme.js";

const MeetChefsComponent = ({ t }) => {
  const chefs = [
    {
      name: <Trans>{"meetChefsComponent.zombieName"}</Trans>,
      image: zombieChef,
    },
    {
      name: <Trans>{"meetChefsComponent.hipsterName"}</Trans>,
      image: hipsterChef,
    },
    {
      name: <Trans>{"meetChefsComponent.ninjaName"}</Trans>,
      image: ninjaChef,
    },
    {
      name: <Trans>{"meetChefsComponent.cyborgName"}</Trans>,
      image: cyborgChef,
    },
    {
      name: <Trans>{"meetChefsComponent.vampireName"}</Trans>,
      image: vampireChef,
    },
  ];

  return (
    <Box sx={{ backgroundColor: "secondary.main" }}>
      <ElipseTop />
      <Grid container flexDirection="column" alignItems="center" pb={10}>
        <Typography variant="h2" mt={15} mb={5}>
          {t("meetChefsComponent.title")}
        </Typography>
        <Container
          sx={{
            width: { xs: "95%", sm: "90%", md: "80%", lg: "65%" },
            height: "87%",
          }}
        >
          <Carousel
            autoplayInterval={10000}
            transitionMode="fade"
            wrapAround
            autoplay
            renderCenterLeftControls={({ previousSlide }) => (
              <BackButton onClick={previousSlide}>
                <img src={back} height="auto" width="auto" alt="back-button" />
              </BackButton>
            )}
            renderCenterRightControls={({ nextSlide }) => (
              <NextButton onClick={nextSlide}>
                <img
                  src={forward}
                  height="auto"
                  width="auto"
                  alt="next-button"
                />
              </NextButton>
            )}
            renderBottomCenterControls={() => null}
          >
            {chefs.map((chef, index, array) => (
              <Grid
                container
                item
                xs={12}
                justifyContent="center"
                alignItems="center"
                key={`chef:${chef.name}`}
                paddingX={{ xs: 0, md: 20 }}
              >
                <Grid container item justifyContent="flex-end" xs={3} mb={5}>
                  {index === 0 ? (
                    <Card>
                      <img
                        src={array[array.length - 1].image}
                        alt={array[array.length - 1].name}
                        width="100%"
                        height="auto"
                      ></img>
                    </Card>
                  ) : (
                    <Card>
                      <img
                        src={array[index - 1].image}
                        alt={array[index - 1].name}
                        width="100%"
                        height="auto"
                      ></img>
                    </Card>
                  )}
                </Grid>
                <Grid item xs={6}>
                  <img src={chef.image} width="100%" alt={chef.name}></img>
                  <Typography variant="h3" textAlign="center" mt={3}>
                    {chef.name}
                  </Typography>
                </Grid>
                <Grid item xs={3} mb={5}>
                  {index === array.length - 1 ? (
                    <Card>
                      <img
                        src={array[0].image}
                        alt={`anothercard: ${array[0].name}`}
                        width="100%"
                        height="auto"
                      ></img>
                    </Card>
                  ) : (
                    <Card>
                      <img
                        src={array[index + 1].image}
                        alt={array[index + 1].name}
                        width="100%"
                        height="auto"
                      ></img>
                    </Card>
                  )}
                </Grid>
              </Grid>
            ))}
          </Carousel>
        </Container>
      </Grid>
      <ElipseBottom />
    </Box>
  );
};

export default withTranslation()(MeetChefsComponent);
